<template>
	<div class="innerBox">

		<div class="row rounded border border-secondary p-10" style="color:white;background-color:black;min-height:500px">
			<!-- <div class="col-3">
				<h5>Preview Gambar Faktur Pembayaran :</h5>

				<img :src="url" v-if="url" style="width:100%;height:auto;max-width:100%;"/>
			</div> -->
			<div class="col-12">
				<div class="row mt-4 text-center">
					<div class="col-3 middleDiv">
						<h5>Account <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.account_transaction_id"
							:options="accountTransaction.map(x => x.id)"
                            :custom-label="opt => accountTransaction.find(x => x.id == opt).account_name"
                            :allow-empty="false"
							class="w-100"
						/>
						<div v-if="form.account_transaction_id" class="mt-3 text-left">
							<h5>Balance : Rp. {{ numberWithCommas(accountTransaction.find( x => x.id == form.account_transaction_id).balance)}}</h5>
						</div>
					</div>
                </div>
				<div class="row mt-4 text-center">
					<div class="col-3 middleDiv">
						<h5>Kategori <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.category"
							:options="options.category.map(x => x.code)"
                            :custom-label="opt => options.category.find(x => x.code == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>

				<div class="row mt-3 text-center" v-if="isRequired('workorder_code')">
					<div class="col-3 middleDiv">
						<h5>Work Order <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.workorder_code"
							:options="options.workorder.map(x => x.code)"
                            :custom-label="opt => options.workorder.find(x => x.code == opt).label"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
				<div class="row mt-3 text-center" v-if="isRequired('sparepart_id')">
					<div class="col-3 middleDiv">
						<h5>Sparepart <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.sparepart_id"
                            :disabled="!form.workorder_code"
							:options="options.sparepart.filter(x => !x.is_supplied_by_insurance).map(x => x.id)"
                            :custom-label="opt => options.sparepart.find(x => x.id == opt).name"
                            :allow-empty="false"
                            class="w-100"
						/>
					</div>
				</div>
                
				<div class="row mt-3 text-center" v-if="isRequired('supplier_id')">
					<div class="col-3 middleDiv">
						<h5>Supplier <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.supplier_id"
							:options="supplierList.map(x => x.id)"
                            :custom-label="opt => options.supplier.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
				</div>

				<div v-if="isRequired('supplier_voucher')">
					<div class="row mt-3 text-center" >
						<div class="col-3 middleDiv">
							<h5>Voucher Type <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7">
							<Multiselect
								v-model="voucherType"
								:options="['PART' , 'BAHAN' , 'JASA', 'DEREK']"
								:allow-empty="false"
								class="w-100"
							/>
						</div>
					</div>
					<div class="row mt-3 text-center" >
						<div class="col-3 middleDiv">
							<h5>Select Supplier Voucher <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7">
							<Multiselect
								:disabled="!voucherType"
								v-model="form.supplier_voucher"
								:options="options.supplier_voucher_filter.map(x => x.sv_code)"
								:custom-label="opt => options.supplier_voucher.find(x => x.sv_code == opt).name"
								:allow-empty="false"
								class="w-100"
							/>
						</div>
					</div>

					<div v-if="detailData" class="mt-4 mb-4 bg-white text-center rounded">
						<table class="table">
							<thead>
								<th>No.</th>
								<th>Nama Sparepart</th>
								<th>Nomor Work Order</th>
								<th>Harga Tercatat</th>
							</thead>
							<tbody v-for="(data , index) in detailData">
								<tr>
									<td>{{index + 1}}.</td>
									<td>{{data.name}}</td>
									<td>{{data.work_order_code}}</td>
									<td>{{numberWithCommas(data.amount)}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
                
				<div class="row mt-3 text-center" v-if="isRequired('labourer_id')">
					<div class="col-3 middleDiv">
						<h5>Pekerja <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.labourer_id"
							:options="options.laborer.map(x => x.id)"
                            :custom-label="opt => options.laborer.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>

				<div class="row mt-3 text-center" v-if="isRequired('description')">
					<div class="col-3 middleDiv">
						<h5>Deskripsi <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<textarea 
							rows="5"
							class="w-100 form-control"
							v-model="form.description"
						/>
					</div>
				</div>

				<div class="row mt-3 text-center" v-if="isRequired('references_no')">
					<div class="col-3 middleDiv">
						<h5>Nomor Referensi Pembayaran <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<textarea 
							rows="2"
							class="w-100 form-control"
							v-model="form.references_no"
						/>
					</div>
				</div>

				<div class="row mt-3 text-center" v-if="isRequired('payment_date')">
					<div class="col-3 middleDiv">
						<h5>Tanggal Pembayaran <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<flat-pickr
							v-model="form.payment_date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>	
					</div>
				</div>


                
				<div class="row mt-3 text-center" v-if="isRequired('month')">
					<div class="col-3 middleDiv">
						<h5>Bulan <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.month"
							:options="options.month.map(x => x.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
				<div class="row mt-3 text-center" v-if="isRequired('year')">
					<div class="col-3 middleDiv">
						<h5>Year <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.year"
							:options="options.year"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
                <!-- AMOUNT, SALARY, OVERTIME, BONUS STARTS -->
				<div class="row mt-3 text-center" v-if="isRequired('salary')">
					<div class="col-3 middleDiv">
						<h5>Gaji <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.salary" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Gaji"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('overtime')">
					<div class="col-3 middleDiv">
						<h5>Lembur <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.overtime" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Lembur"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('bonus')">
					<div class="col-3 middleDiv">
						<h5>Bonus <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.bonus" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Bonus"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('amount')">
					<div class="col-3 middleDiv">
						<h5>Jumlah Uang <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" :disabled="form.category == 'pembayaran_voucher'" v-model="form.amount" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Uang"/>
					</div>
				</div>
                <!-- AMOUNT, SALARY, OVERTIME, BONUS, ENDS -->

				<div class="row mt-3 text-center" v-if="isRequired('value_payable')">
					<div class="col-3 middleDiv">
						<h5>Pajak Yang Dibayar <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.value_payable" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Uang" disabled/>
					</div>
				</div>

				<div class="row mt-3 text-center" v-if="isRequired('proof_img')">
					<div class="col-3 middleDiv">
						<h5>Unggah Gambar</h5>
						( Maximum 4 MB per File )
						
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<span v-if="fileError != ''" class="mb-2" style="color:red;font-weight:bold">{{fileError}}</span>
						<input type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize"/>
					</div>
                </div>
                
                <div class="row">
                    <div class="col-7 offset-6">
                        <p class="text-red m-0">* Harus di-isi</p>
                        <p class="text-orange m-0" v-if="form.category == 'labourer_wage'">** Isi 0 jika tidak ada</p>
                    </div>
                </div>

				<div class="row mt-4">
					
					<div class="offset-6 col-3">
						
						<!-- <button class="btn btn-danger w-100">Batal</button> -->
					</div>
					<div class="col-3" >
						<button class="btn btn-primary w-100" @click="submit">Selesai</button>
					</div>
				</div>
			</div>
		</div>

		<preview-image
			v-if="modal.showImage"
			@closeModal="modal.showImage = false"
			:title="'Gampar Sparepart'"
			:image="imagesList"
		></preview-image>

		
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import previewImage from '@/components/modal/previewImage'
import env from '@/env'
export default {
	components : {
		Multiselect,
		previewImage
	},
	props : ['accountTransaction'],
	data () {
		return {
            moment : moment,
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
			},
			voucherType : 'PART' ,
            numberFields : ['salary', 'overtime', 'bonus', 'amount'],
            requiredFields : {
                supplier_part : ['category', 'supplier_id', 'amount', 'proof_img'],
				pembayaran_voucher : ['supplier_voucher' , 'amount' , 'proof_img' , 'references_no' , 'payment_date'],
				supplier_bahan : ['category', 'supplier_id', 'amount', 'proof_img'],
                labourer_wage : ['category', 'labourer_id', 'salary', 'overtime', 'bonus', 'proof_img'],
                donation : ['category', 'amount', 'proof_img', 'payment_date'],
                tax_payable : ['category', 'month', 'year', 'value_payable'],
                other : ['category', 'amount', 'description', 'proof_img' , 'payment_date']
            },
			modal : {
				showImage : false
			},
			imagesList : null,
			form : {
                category : 'pembayaran_voucher',
                workorder_code : '',
                sparepart_id : '',
                supplier_id : '',
                labourer_id : '',
                description : '',
                month : moment().month(),
                year : moment().year(),
				supplier_voucher : null,

                amount : '',
                salary : '',
                overtime : '',
                bonus : '',
                value_payable : '',

                proof_img : '',
				account_transaction_id : ''
            },
            options : {
                category : [
                    // {code : 'supplier_part', name : 'Supplier Part'},
					// {code : 'supplier_bahan', name : 'Supplier Bahan'},
					{code : 'pembayaran_voucher' , name : 'Pembayaran Supplier Voucher'},
                    {code : 'labourer_wage', name : 'Gaji Karyawan'},
                    {code : 'donation', name : 'Donasi'},
                    {code : 'tax_payable', name : 'Pembayaran Pajak'},
                    {code : 'other', name : 'Other'},
                ],
                workorder : [],
                sparepart : [],
                supplier : this.$store.getters.getSupplier,
                laborer : this.$store.getters.getLaborer,
                month : this.$store.getters.getMonth,
                year : this.$store.getters.getYear,
				supplier_voucher : [],
				supplier_voucher_filter : []
            },
			file : null,
			url : null,
			fileError : '',
			labourerList : null,
			pending_payment : null,
			pending_payment_bahan : null,
			ongoing : [], 
			supplierList : [],
			detailData : null
		}
    },
	watch : {
		voucherType : function () {
			this.options.supplier_voucher_filter = this.options.supplier_voucher.filter(x => 
				x.type == this.voucherType
			)
		},
		'form.supplier_voucher' : function () {
			this.getVoucherDetails()
		},
        'form.month' : { handler : 'getTaxPayable' },
        'form.year' : { handler : 'getTaxPayable' },
		'form.category' : function () {
			this.pending_payment = null
			this.ongoing = []
			this.loadSupplierList()
		},
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
        },
		'form.salary' : function () {
			const result = this.form.salary.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.salary = result);
        },
		'form.overtime' : function () {
			const result = this.form.overtime.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.overtime = result);
        },
		'form.bonus' : function () {
			const result = this.form.bonus.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.bonus = result);
        },

        'form.workorder_code' : function () {
            this.form.sparepart_id = null;
            if (this.form.workorder_code) this.getListOfSparepart(this.form.workorder_code);
        },
		'form.supplier_id' : function () {
			this.pending_payment = null
			if(this.form.category == 'supplier_part') {
				if(!this.form.supplier_id)
					return
				this.loadVoucher(this.form.supplier_id)
			}
			else if (this.form.category == 'supplier_bahan') {
				if(!this.form.supplier_id)
					return
				this.loadVoucherBahan(this.form.supplier_id)
			}
		},
		'ongoing' : function () {
			let amountTotal = 0
			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let amount = parseFloat(this.ongoing[i].amount)
				let price = parseFloat(this.ongoing[i].price_per_item)

				amountTotal += (amount * price)
			}
			this.form.amount = this.numberWithCommas(amountTotal)
		}
	},
	mounted () {
        this.getListOfWorkOrder();
        this.getTaxPayable();
		this.loadSupplierList()
		this.loadSupplierVoucher()
	},
	methods : {
		getVoucherDetails () {
			this.$http.get('/api/v1/treasury/supplier-voucher/' + this.form.supplier_voucher)
			.then((resp) => {
				this.detailData = resp.data.data
				this.form.amount = 0

				for(var i = 0 ; i < this.detailData.length ; i++) {
					this.form.amount += parseFloat(this.detailData[i].amount)
				}
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again later.'])
				console.log(err)
			})
		},
		loadSupplierVoucher () {
			this.$http
				.get("/api/v1/treasury/supplier-voucher?pagination=false&pending=1")
				.then((resp) => {
					// this.data = resp.data.data

					let data = resp.data.data;
					

					for(var i = 0 ; i < data.length ; i++) {
						data[i].name = `${data[i].workorder_code ? data[i].workorder_code + ' -' : ''} ${data[i].sv_code} - ${data[i].name} - ${data[i].registration}`
					}

					this.options.supplier_voucher = data
					this.options.supplier_voucher_filter = data.filter(x => x.workorder_code != null)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		loadSupplierList () {
			let type = ''
			this.form.category == 'supplier_part' ? type =  'P' : this.form.category == 'supplier_bahan' ? type = 'B' : ''
			if(type == '') 
				return
			this.$http.get(`/api/v1/purchase-order/supplier-voucher/supplier-list?type=${type}`)
			.then((resp) => {
				this.supplierList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			})
		},
		clickAll() {
			if(this.pending_payment_bahan)
				this.ongoing = JSON.parse(JSON.stringify(this.pending_payment_bahan))
			else {
				// for(var i = 0; i < this.pending_payment.length ; i++) {
					
				// }
				this.$store.dispatch('triggerAlert' , [false , 'Fitur lagi maintanence.'])
			}
		},
		reset() {
			this.ongoing = []
		},
		showImage (imagesList) {
			this.imagesList = imagesList
			this.modal.showImage = true
		},
		loadVoucherBahan (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher/bahan?supplier_id=${supplier_id}`)
			.then((resp) => {
				this.pending_payment_bahan = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			})
		},
		loadVoucher (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher?supplier_id=${supplier_id}`)
			.then((resp) => {
				let pending_payment = resp.data.data
				let newObj = {}

				for(var i = 0 ; i < pending_payment.length ; i++) {

					let ppn = pending_payment[i].ppn_included

					let without_ppn = pending_payment[i].without_ppn

					if(ppn == 0 && !without_ppn) {
						pending_payment[i].price_per_item = parseFloat(pending_payment[i].price_per_item) * 1.1
						
					}

					pending_payment[i].estimation_price = (parseFloat(pending_payment[i].price_per_item) + parseFloat(pending_payment[i].markup)) *  parseFloat(pending_payment[i].amount)



					if(!pending_payment[i].time_of_arrival) {
						pending_payment[i].aging = '-'
					}
					else {
						let b = moment(pending_payment[i].time_of_arrival)
						let a = moment()

						var years = a.diff(b, 'year');
						b.add(years, 'years');

						var months = a.diff(b, 'months');
						b.add(months, 'months');

						var days = a.diff(b, 'days');

						pending_payment[i].aging = `${years > 0 ? years + ' T' : ''} ${months > 0 ? months + ' B' : ''} ${days > 0 ? days + ' H' : ''}`
					}

					if(pending_payment[i].delivery_photo.includes(',')) {
						pending_payment[i].delivery_photo = pending_payment[i].delivery_photo.split(',')
						for(var j = 0 ; j < pending_payment[i].delivery_photo.length ; j++) {
							if(!pending_payment[i].delivery_photo[j].includes(env.baseImage))
								pending_payment[i].delivery_photo[j] = env.baseImage + '/' + pending_payment[i].delivery_photo[j]
						}
					}
					else {
						pending_payment[i].delivery_photo = [env.baseImage + '/' + pending_payment[i].delivery_photo]
					}

					!newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] ? newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] = [pending_payment[i]] : newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name].push(pending_payment[i])
				}
				this.pending_payment = newObj
			})
			.catch((err) => {
				console.log(err)
			})
		},
        isRequired (field) {
            return (this.requiredFields[this.form.category].indexOf(field) !== -1) ? true : false
        },
        resetForm () {
            for (var i in this.form) {
                if (
                    i !== 'category' &&
                    i !== 'month' &&
                    i !== 'year' &&
                    i !== 'value_payable'
                ) this.form[i] = ''
            }

			this.pending_payment = null
			this.ongoing = null
        },
		getListOfWorkOrder () {
			this.$http.get('/api/v1/masterData/workorder?pagination=false')
			.then((resp) => {
				this.options.workorder = resp.data.data.map(x=>{return{code:x.form_code, label:`${x.form_code} - ${x.no_polisi}`}});
			})
			.catch((err) => { console.log(err) })
		},
        getListOfSparepart (workorder) {
            this.$http.get(`/api/v1/workorder-estimation/${workorder}`)
            .then((resp)=>{
                this.options.sparepart = resp.data.data.estimations.filter(x=>x.sparepart_type=='P'&&x.is_supplied_by_insurance!=1).map(x=>{return {id:x.id, name:x.sparepart_name}})
            })
            .catch((err)=>{console.log(err)})
        },
		validateSize(data) {
			var file = data.target.files[0];

			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				this.fileError = "Limit Size Gambar 8 MB";
				return false;
			}

			this.fileError = "";
			this.file = file ;
			this.url = URL.createObjectURL(file);

			return true;
		},
		async uploadImage () {
			let formData = new FormData()
			let image = null

			formData.append('work_order', this.file)

			
			let response = await this.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})
			
			image = response.data.data.filename

			return image
        },
        async evaluateForm () {
            let errors = []
            let keys = this.requiredFields[this.form.category];

            //Check valid
            for(var i in keys) {
				if(keys[i] == 'proof_img') {
					if(this.file) {
						let image = await this.uploadImage()
						this.form.proof_img = image
					}
				}
				else if(this.form[keys[i]] == '' || this.form[keys[i]] == null) {
					errors.push(`${this.translate(keys[i])} Wajib Dipilih Atau Diisi`)
				}
            }

            //If any error is detected
            if (errors.length > 0) {
                this.$store.dispatch('triggerAlert', [false, errors]);
                return null;
            }

            //Create object for 'form', get all it's keys
            let data = JSON.parse(JSON.stringify(this.form));
            let formKeys = Object.keys(this.form);

            //Cleanse commas(,) on number fields
            // for (var i in this.numberFields) data[this.numberFields[i]] = parseFloat(data[this.numberFields[i]].split(',').join(''))
// 
            //Cleanse form field where it is not needed
            for (var i in formKeys) if (keys.indexOf(formKeys[i]) === -1) delete data[formKeys[i]];

            return data;

        },
		async submit() {
            //If tax payable, refer to another function
            if (this.form.category == 'tax_payable') {
                this.commitTaxTransaction();
                return;
            }

		    let form = await this.evaluateForm()

            //Error detected
            if (!form) return;

			if(this.form.category == 'supplier_part') {
				this.commitSupplierPayment(form)
				return
			}
			else if (this.form.category == 'supplier_bahan') {
				this.commitSupplierBahanPayment(form)
				return
			}

            this.fileError = ''
			form.account_transaction_id = this.form.account_transaction_id
			form.category = this.form.category
			form.amount = parseFloat(form.amount.split(',').join(''))
			if(!form.proof_img) delete form.proof_img
            this.$http.post(`/api/v1/treasury/ledger?account_transaction_id=${form.account_transaction_id}` , form)
            .then((resp) => {
                this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
				this.$emit('recheckBalance')
                this.resetForm();
            })
            .catch((err) => {
                console.log(err)
            })
        },
		async getLastIndex (supplier_id , type) {
			try {
				let response = await this.$http.post('/api/v1/treasury/supplier-voucher/index?supplier_id=' + supplier_id , {type : type})
				// console.log(response)
				return response.data.data.sv_id	
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Fetching Supplier Code. Please Try Again Later.'])
				console.log(err)
			}
		},
		async commitSupplierBahanPayment (form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'BAHAN')

			if(!svCounter) return

			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let curr = this.ongoing[i]

				let data = Object.assign({} , form)

				data.transaction_id = curr.transaction_id
				data.sparepart_id = curr.spare_part_id
				data.sparepart_name = curr.sparepart_name
				data.amount = parseFloat(curr.price_per_item) * parseFloat(curr.amount)
				data.sv_id = svCounter
				data.account_transaction_id = this.form.account_transaction_id
				this.$http.post(`/api/v1/treasury/ledger` , data)
				.then((resp) => {
					if(length == counter)
						this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
					else
						counter++
					this.resetForm();
					this.$emit('recheckBalance')
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		async commitSupplierPayment(form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'PART')

			if(!svCounter) return
			

			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let curr = this.ongoing[i]

				let data = Object.assign({} , form)

				data.workorder_code = curr.form_code
				data.sparepart_id = curr.sparepart_id
				data.sparepart_name = curr.sparepart_name
				data.amount = parseFloat(curr.price_per_item) * parseFloat(curr.amount)
				data.estimation_id = curr.estimation_id
				data.sv_id = svCounter
				data.account_transaction_id = this.form.account_transaction_id
				console.log(this.form , form)
				this.$http.post(`/api/v1/treasury/ledger` , data)
				.then((resp) => {
					if(length == counter)
						this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
					else
						counter++
					this.resetForm();
					this.$emit('recheckBalance')
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},

		translate (word) {
            let dictionary = {
                category : 'Kategori',
                workorder_code : 'Work Order',
                sparepart_id : 'Sparepart',
                supplier_id : 'Supplier',
                labourer_id : 'Pekerja',
                description : 'Deskripsi',
                salary : 'Gaji',
                overtime : 'Lembur',
                bonus : 'Bonus',
                amount : 'Jumlah Uang',
                proof_img : 'Gambar Faktur Pembayaran',
            }

			return dictionary[word]
        },
        getTaxPayable () {
            this.$http.get(`/api/v1/treasury/tax-payable?month=${this.form.month}&year=${this.form.year}`)
            .then((resp)=>{
                this.form.value_payable = this.numberWithCommas(resp.data.data);
            })
            .catch((err)=>{console.log(err)})
        },
        commitTaxTransaction () {
            this.$http.post(`/api/v1/treasury/tax-payable?month=${this.form.month}&year=${this.form.year}`)
            .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, `Pajak berhasil dibayar.`]);
                this.resetForm();
            })
            .catch((err)=>{console.log(err)})
        },
	}
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
</style>